import { i18nFilter } from "app/filters/i18nFilter";
import { APPLE_STORE, AppStoreName, EStores } from "app/pages/app-intelligence/constants";

import { chosenItems } from "app/common/services/chosenItems";
import type { IDeviceFilterItem } from "app/pages/app-intelligence/common-components/device-picker/types";
import { EDevice } from "app/pages/app-intelligence/common-components/device-picker/types";

const isAppleStore = (id: string) => {
    return id.startsWith("1_");
};

const getStorePrefix = (id: string) => {
    return `${EStores[id]}_`;
};

const translate = i18nFilter();
const getAndroidDevices = (shouldUseCombined = false): IDeviceFilterItem[] => [
    {
        id: shouldUseCombined ? EDevice.COMBINED : EDevice.ALL_DEVICES,
        text: translate("apps.overview.devicePicker.android.allDevices"),
        icon: "tablet-and-mobile",
    },
    {
        id: EDevice.ANDROID_PHONE,
        text: translate("apps.overview.devicePicker.androidPhone"),
        icon: "mobile-web",
    },
    {
        id: EDevice.ANDROID_TABLET,
        text: translate("apps.overview.devicePicker.androidTablet"),
        icon: "tablet",
    },
];
const getIosDevices = (shouldUseCombined = false): IDeviceFilterItem[] => [
    {
        id: shouldUseCombined ? EDevice.COMBINED : EDevice.ALL_DEVICES,
        text: translate("apps.overview.devicePicker.ios.allDevices"),
        icon: "tablet-and-mobile-ios",
    },
    {
        id: EDevice.IPHONE,
        text: translate("apps.overview.devicePicker.iPhone"),
        icon: "mobile-ios",
    },
    {
        id: EDevice.IPAD,
        text: translate("apps.overview.devicePicker.iPad"),
        icon: "tablet-ios",
    },
];

const getDeviceTranslatedByType = (deviceType: string, store?: string): IDeviceFilterItem => {
    const isAppleStore = chosenItems[0]?.AppStore === APPLE_STORE || store === APPLE_STORE;
    const devices = isAppleStore ? getIosDevices() : getAndroidDevices();
    const selectedDevice = devices.find((device) => device.id === deviceType);
    return selectedDevice ?? devices[0];
};

const getRelevantDevicesList = (
    store = chosenItems.$first().AppStore,
    toParams = null,
    iosDevices = null,
    androidDevices = null,
    shouldUseCombined = false,
) => {
    return store.toLowerCase() === AppStoreName.APPLE.toLowerCase()
        ? iosDevices ?? DeviceService.getIosDevices(shouldUseCombined)
        : androidDevices ?? DeviceService.getAndroidDevices(shouldUseCombined);
};

export const DeviceService = {
    isAppleStore,
    getStorePrefix,
    getDeviceTranslatedByType,
    getIosDevices,
    getAndroidDevices,
    getRelevantDevicesList,
};
